import PageLoader from './components/pageLoader';
import {registerReducer} from '../../bloom';
import AppReducer from './reducers/appReducer';

registerReducer('app', AppReducer);

export {PageLoader};